import { sessionManagerApi } from './apiClient';

export interface SupportConversationContext {
  threadId: string;
  escalationId: string;
  humanSessionId: string;
  sourceTeachingSessionId: string | null;
  sourceItemId: string | null;
}
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
function context(value: unknown): SupportConversationContext {
  if (!value || typeof value !== 'object') throw new Error('Support context unavailable');
  const v = value as SupportConversationContext;
  if (![v.threadId, v.escalationId, v.humanSessionId].every(id => typeof id === 'string' && UUID.test(id)) ||
    !(v.sourceTeachingSessionId === null || (typeof v.sourceTeachingSessionId === 'string' && v.sourceTeachingSessionId.length <= 255)) ||
    !(v.sourceItemId === null || (typeof v.sourceItemId === 'string' && UUID.test(v.sourceItemId)))) throw new Error('Support context unavailable');
  return v;
}
export async function openSupportFollowUp(escalationId: string, capturedToken?: string): Promise<SupportConversationContext> {
  if (!UUID.test(escalationId)) throw new Error('Support source unavailable');
  const result = await sessionManagerApi.post(`/support/escalations/${escalationId}/follow-up`, {},
    capturedToken ? { headers: { Authorization: `Bearer ${capturedToken}` } } : undefined);
  const value = context(result.data);
  if (value.escalationId !== escalationId) throw new Error('Support source mismatch');
  return value;
}
export async function getSupportContext(threadId: string, capturedToken?: string): Promise<SupportConversationContext | null> {
  if (!UUID.test(threadId)) return null;
  const result = await sessionManagerApi.get(`/support/threads/${threadId}/context`,
    capturedToken ? { headers: { Authorization: `Bearer ${capturedToken}` } } : undefined);
  if (result.data?.context === null) return null;
  const value = context(result.data?.context);
  if (value.threadId !== threadId) throw new Error('Support thread mismatch');
  return value;
}
